<template>
  <div class="sponsorpage">
    <h2>
      <!-- 冠名赞助 -->
      <div>
        <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/title%26bg/homeNamed_en.png" alt="" />
      </div>
    </h2>
    <vueSeamless class="sponsor" :data="listData" :class-option="defaultOption" ref="item">
      <ul class="item" >
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/jierui.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/dfxk.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/jly.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/shenkai.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/nyej.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/bl.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/zhonghy.png" alt="" />
        </li>
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/brand/tiehu.png" alt="" />
        </li>
      </ul>
    </vueSeamless>
  </div>
</template>

<script>
import vueSeamless from 'vue-seamless-scroll'
export default {
  components:{
    vueSeamless
  },
  data(){
    return{
      listData:[1,2,3,4,5,6,7,8],
    }
  },
  
  mounted(){
      this.height = this.$refs.item.offsetHight/2
  },
  computed:{
    defaultOption(){
      return{
        direction: 1,
        limitMoveNum: this.listData.length,
        hoverStop: true,
        openWatch: true,
        waitTime:2500,
        singleHeight: 120
      }
    }
  }
}
</script>

<style scoped>
  .sponsorpage{
    padding-bottom: 60px;
  }
  h2{
    text-align: center;
    padding: 70px 0 50px 0;
    font-size: 40px;
    color: #494c4d;
  }
  h2>div{
    /* width: 300px; */
    height: 80px;
    overflow: hidden;
    margin: 0 auto;
  }
  h2>div img{
    width: auto;
    height: auto;
  }
  .sponsor{
    height: 256px ;
    max-width: 1200px;
    padding: 0 20px;
    margin:  0 auto;
    overflow: hidden;
    border:5px solid #008baf;
    background-color: rgba(255, 255, 255, .9);
  }
  .item{
    max-width: 1200px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .item::after{
    content: "";
    width: 270px;
  }
  .item>li{
    width: 270px;
    height: 123px;
    text-align: center;
    vertical-align: middle;
  }
  .item>li>img{
    width: 100%;
    height: auto;
    object-fit: contain;
    border: 1px solid #aaa;
    margin-top: 18px;
  }
</style>